import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import "./ErrorMessage.scss"

const ErrorMessage = ({ text, className }) => {
  if (!text) return null

  return (
    <Flex
      className={`prime-error-message${className ? " " + className : ""}`}
      align="center"
      gap={6}
    >
      <i className="fal fa-exclamation-circle" />
      <span className="prime-error-text">{text}</span>
    </Flex>
  )
}

ErrorMessage.propTypes = {
  text: PropTypes.string,
}

export default ErrorMessage
